import { browser } from '$app/environment';

type LandingBootDetails = Record<string, string | number | boolean | null | undefined>;

type LandingBootState = {
	step: number;
	last: number;
};

declare global {
	interface Window {
		__iliadLandingBoot?: LandingBootState;
		__iliadLandingBootLog?: (event: string, details?: LandingBootDetails) => void;
	}
}

function isLandingPage(): boolean {
	return browser && window.location.pathname === '/';
}

export function logLandingBoot(event: string, details: LandingBootDetails = {}): void {
	if (!isLandingPage()) return;

	if (window.__iliadLandingBootLog) {
		window.__iliadLandingBootLog(event, details);
		return;
	}

	const now = performance.now();
	const state = (window.__iliadLandingBoot ??= { step: 0, last: now });
	const delta = now - state.last;
	state.last = now;
	const populatedDetails = Object.fromEntries(
		Object.entries(details).filter(([, value]) => value !== undefined)
	);
	console.log(
		`[Iliad Landing Boot] #${String(++state.step).padStart(2, '0')} +${now.toFixed(1)}ms (+${delta.toFixed(1)}ms) ${event}`,
		populatedDetails
	);
}

export function logLandingResourceSummary(label: string): void {
	if (!isLandingPage()) return;

	const resources = performance
		.getEntriesByType('resource')
		.filter(
			(entry): entry is PerformanceResourceTiming => entry instanceof PerformanceResourceTiming
		)
		.filter((entry) => {
			const name = entry.name;
			return (
				entry.initiatorType === 'script' ||
				entry.initiatorType === 'css' ||
				entry.initiatorType === 'link' ||
				entry.initiatorType === 'fetch' ||
				name.includes('/_app/') ||
				name.includes('/aqueduct/') ||
				name.includes('/fonts/') ||
				name.includes('font-awesome') ||
				name.includes('sentry-cdn')
			);
		})
		.sort((a, b) => b.duration - a.duration)
		.slice(0, 16)
		.map((entry) => ({
			name: entry.name.replace(window.location.origin, ''),
			type: entry.initiatorType,
			start: Number(entry.startTime.toFixed(1)),
			duration: Number(entry.duration.toFixed(1)),
			transfer: entry.transferSize,
			encoded: entry.encodedBodySize,
			decoded: entry.decodedBodySize
		}));

	logLandingBoot(label, {
		documentReadyState: document.readyState,
		resourceCount: performance.getEntriesByType('resource').length
	});
	console.table(resources);
}
